import { useQuery } from '@tanstack/react-query';
import { therapistsApi } from '../api/therapistsApi';
import { PublicTherapist, TherapistForService } from '../types/booking.types';

/**
 * Hook for fetching all public therapists
 */
export const useTherapists = () => {
  return useQuery<PublicTherapist[], Error>({
    queryKey: ['therapists'],
    queryFn: () => therapistsApi.getAll(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000,
  });
};

/**
 * Hook for fetching therapists for a specific service
 */
export const useTherapistsForService = (serviceId: string) => {
  return useQuery<TherapistForService[], Error>({
    queryKey: ['therapists', 'service', serviceId],
    queryFn: () => therapistsApi.getByService(serviceId),
    enabled: !!serviceId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};

/**
 * Hook for fetching a single therapist by ID
 */
export const useTherapist = (id: string) => {
  return useQuery<PublicTherapist | null, Error>({
    queryKey: ['therapist', id],
    queryFn: () => therapistsApi.getById(id),
    enabled: !!id,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};
